export const EducationAndQualificationType = {
  CERTIFICATION: "CERTIFICATION",
} as const;
